module.exports = __webpack_public_path__ + "fonts/Gotham-BoldItalic.0bd8724b.otf";